import { render } from "./AdminComponents.html?vue&type=template&id=2b95acdb&external"
import script from "./AdminComponents.js?vue&type=script&lang=js&external"
export * from "./AdminComponents.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__